import { Tag, Typography } from "antd";
import { FC } from "react";

interface DrawerTitleProps {
    mainTitle: string;
    subTitles?: (string | null | undefined)[];
}

export const DrawerTitle: FC<DrawerTitleProps> = ({ mainTitle, subTitles }) => {
    const renderSubTitles = () =>
        subTitles?.filter(Boolean).map((subTitle, index) => <Tag key={`subtitle-${index}`}>{subTitle}</Tag>);

    return (
        <div className={"mt-3"}>
            <Typography.Title level={3}>{mainTitle}</Typography.Title>
            {renderSubTitles()}
        </div>
    );
};
